import { useState, useMemo, useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrendingSection from './components/TrendingSection';
import ArticleCard from '@/components/base/ArticleCard';
import CategoryTabs from '@/components/base/CategoryTabs';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function Home() {
  useEffect(() => {
    document.title = '黑料吃瓜网 - 黑料吃瓜网曝一区二区 在线观看 站在线观看 | 免费高清完整视频在线播放';
  }, []);

  const [activeTab, setActiveTab] = useState('');

  const filteredArticles = useMemo(() => {
    if (!activeTab) return articles;
    return articles.filter((a) => a.category === activeTab);
  }, [activeTab]);

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '黑料吃瓜网 - 首页',
    description: '黑料吃瓜网曝一区二区、在线观看、站在线观看等分区视频资源，免费高清完整视频在线播放',
    url: 'https://heiliaochigua.com',
    isPartOf: {
      '@type': 'WebSite',
      name: '黑料吃瓜网',
      url: 'https://heiliaochigua.com',
    },
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <Navbar />
      <main>
        <HeroSection />

        <section className="max-w-7xl mx-auto px-4 md:px-6 py-8">
          <CategoryTabs categories={categories} activeSlug={activeTab} />

          <div className="mt-8 grid grid-cols-1 lg:grid-cols-4 gap-8">
            <div className="lg:col-span-3">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {filteredArticles.slice(0, 9).map((article) => {
                  const cat = categories.find((c) => c.slug === article.category);
                  return (
                    <ArticleCard
                      key={article.id}
                      slug={article.slug}
                      title={article.title}
                      excerpt={article.excerpt}
                      image={article.image}
                      date={article.date}
                      views={article.views}
                      tags={article.tags}
                      categoryName={cat?.name}
                      categorySlug={cat?.slug}
                    />
                  );
                })}
              </div>

              {filteredArticles.length > 9 && (
                <div className="mt-8 text-center">
                  <button
                    type="button"
                    className="px-6 py-2.5 border border-background-300 rounded-full text-sm text-foreground-700 hover:bg-background-100 hover:border-primary-300 transition-all duration-200 cursor-pointer whitespace-nowrap"
                  >
                    加载更多内容
                  </button>
                </div>
              )}
            </div>

            <div className="lg:col-span-1">
              <TrendingSection />
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-12">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-2">
                <i className="ri-flashlight-line w-5 h-5 flex items-center justify-center text-primary-500"></i>
                <h2 className="font-heading text-xl text-foreground-950">最新资讯</h2>
              </div>
              <a href="#more" className="text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                查看全部 <i className="ri-arrow-right-line w-4 h-4 inline-flex items-center justify-center"></i>
              </a>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {articles.slice(10, 18).map((article) => {
                const cat = categories.find((c) => c.slug === article.category);
                return (
                  <ArticleCard
                    key={article.id}
                    slug={article.slug}
                    title={article.title}
                    excerpt={article.excerpt}
                    image={article.image}
                    date={article.date}
                    views={article.views}
                    tags={article.tags}
                    categoryName={cat?.name}
                    categorySlug={cat?.slug}
                  />
                );
              })}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}